export default function DailyReportDemo() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4">
          自由に報告するだけで、進捗表が更新される
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">
          日報を書くだけで、AIが完了タスクと次の作業を整理します
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-[960px] mx-auto">
          <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                <i className="ri-edit-line text-primary-600 text-sm"></i>
              </div>
              <span className="text-sm font-semibold text-foreground-700">日報入力</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed bg-background-50 rounded-md p-4 border border-background-200/70">
              「今日はログイン画面のデザインを完了しました。API接続は認証方式の確認待ちです。明日はエラー画面を作ります。」
            </p>
          </div>

          <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-accent-100 rounded-full flex items-center justify-center">
                <i className="ri-magic-line text-accent-600 text-sm"></i>
              </div>
              <span className="text-sm font-semibold text-foreground-700">AI解析結果</span>
            </div>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-check-line text-green-600 text-xs"></i>
                </span>
                <span className="text-foreground-700">ログイン画面デザイン：<strong className="text-green-700">完了</strong></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-amber-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-time-line text-amber-600 text-xs"></i>
                </span>
                <span className="text-foreground-700">API接続：<strong className="text-amber-700">確認待ち</strong></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-arrow-right-line text-blue-600 text-xs"></i>
                </span>
                <span className="text-foreground-700">エラー画面作成：<strong className="text-primary-700">次のタスク</strong></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 rounded-full bg-red-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-alert-line text-red-600 text-xs"></i>
                </span>
                <span className="text-foreground-700">課題：<strong className="text-red-700">認証方式の確認が必要</strong></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}